export { default as Configuration } from 'secured/components/layout/menu/Configuration';
export { default as ControlPanel } from 'secured/components/layout/menu/ControlPanel';
export { default as Reports } from 'secured/components/layout/menu/Reports';



// WEBPACK FOOTER //
// src/modules/secured/components/layout/menu/index.js